import Time                            from "../fundamentals/date/Time";
import ReservationBusinessDayTypeClass from "./ReservationBusinessDayTypeClass";
import ReservationWeekTypeClass        from "./ReservationWeekTypeClass";

export default class ReservationBusinessTime {
  constructor(
    private readonly _weekType: ReservationWeekTypeClass = new ReservationWeekTypeClass(),
    private readonly _dayType: ReservationBusinessDayTypeClass = new ReservationBusinessDayTypeClass(),
    private readonly _from: Time = Time.ofText("00:00"),
    private readonly _to: Time = Time.ofText("00:00")
  ) {
  }

  get weekType() {
    return this._weekType;
  }

  get dayType() {
    return this._dayType;
  }

  get from() {
    return this._from;
  }

  get to() {
    return this._to;
  }
}